import { DateTime } from 'luxon'

import { ArgentoInsurancePaymentPeriodicities } from '~/config'

export type PaymentInfo = Nullable<{
  cc: string
  exp: Date
  ccv: string
  type: string
  argentoInsurancePaymentPeriodicity: PropsTypesOf<
    typeof ArgentoInsurancePaymentPeriodicities
  >['value']
  argentoInsurancePaymentConditionId: number
  discountTag: string
  discountType: SiteApiSchema<'BrokerProductoDescuentoTipo'>
  discountAmount: number
}>

function load(model?: Partial<PaymentInfo> | null): PaymentInfo {
  return {
    cc: model?.cc ?? null,
    exp: model?.exp ?? null,
    ccv: model?.ccv ?? null,
    type: model?.type ?? null,
    argentoInsurancePaymentPeriodicity: model?.argentoInsurancePaymentPeriodicity ?? null,
    argentoInsurancePaymentConditionId: model?.argentoInsurancePaymentConditionId ?? null,
    discountTag: model?.discountTag ?? null,
    discountType: model?.discountType ?? null,
    discountAmount: model?.discountAmount ?? null,
  }
}

const map = {
  toPagoInfoViewModel(model: PaymentInfo): SiteApiSchema<'PagoInfoViewModel'> {
    return {
      formaPago: 'TARJETA',
      cvvTarjeta: model.ccv,
      frecuenciaPago: model.argentoInsurancePaymentPeriodicity
        ? ArgentoInsurancePaymentPeriodicities[
            model.argentoInsurancePaymentPeriodicity
          ].text.toUpperCase()
        : undefined,
      mesTarjeta: model.exp
        ? DateTime.fromJSDate(model.exp).month.toString().padStart(2, '0')
        : undefined,
      yearTarjeta: model.exp ? DateTime.fromJSDate(model.exp).year.toString() : undefined,
      numeroTarjeta: model.cc?.replace(/\D/g, '').trim(),
      tipoTarjeta: model.type ?? undefined,
    }
  },
}

export const PaymentInfo = {
  load,
  map,
}
